import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2, DOCUMENT } from '@angular/core';

import { Router } from '@angular/router';
import { AuthService } from '../../../core/service/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { PublicDataService } from '../../../core/service/public-data.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private translate: TranslateService,
    public publicDataSvc: PublicDataService,
    public authSvc: AuthService
  ) { }

  ngOnInit(): void {
  }

  onChangeLanguageTo(codeLang: string) {
    this.translate.use(codeLang);
    const language = this.publicDataSvc.languages.find((l) => l.code === codeLang);
    if (language?.id !== undefined) {
      this.authSvc.changeLanguage(language.id);
    }

  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    e.preventDefault();
    this.authSvc.logout();

  }

}
